var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99463 5.46619V8.44088",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0149 1.5C6.29464 1.5 3.28205 4.16204 3.28205 7.4494V9.32533C3.28205 9.93278 2.99898 10.8439 2.64516 11.3621L1.36127 13.2559C0.572737 14.4261 1.11864 15.7303 2.57439 16.1591C7.40667 17.5794 12.6332 17.5794 17.4655 16.1591C18.8302 15.7571 19.4166 14.3457 18.6786 13.2559L17.3947 11.3621C17.0409 10.8439 16.7578 9.92384 16.7578 9.32533V7.4494C16.7477 4.17991 13.7149 1.5 10.0149 1.5Z",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3611 16.5254C13.3611 18.1601 11.8447 19.5001 9.99465 19.5001C9.0747 19.5001 8.22551 19.1606 7.61895 18.6247C7.01239 18.0887 6.62823 17.3383 6.62823 16.5254",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.4ace624be751b13910a93224a6813dc0.svg";
export { ForwardRef as ReactComponent };